import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Tab-scoped auth token: sessionStorage is isolated per browser tab, so two Customer
// Organizations logged in on the same origin (different tabs) never overwrite each other.
const TOKEN_KEY = "petrinos-access-token";
export const tokenStore = {
  get: () => { try { return sessionStorage.getItem(TOKEN_KEY); } catch { return null; } },
  set: (t) => { try { t ? sessionStorage.setItem(TOKEN_KEY, t) : sessionStorage.removeItem(TOKEN_KEY); } catch { /* ignore */ } },
  clear: () => { try { sessionStorage.removeItem(TOKEN_KEY); } catch { /* ignore */ } },
};

export const api = axios.create({
  baseURL: API,
  withCredentials: true, // cookie kept as fallback (e.g. <img> logo requests)
});

// Send the tab's Bearer token; the backend prefers it over the origin-wide cookie.
api.interceptors.request.use((config) => {
  const t = tokenStore.get();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function apiError(e) {
  return formatApiErrorDetail(e?.response?.data?.detail) || e?.message || "Request failed";
}
